import { gql, useQuery as useApolloQuery } from '@apollo/client';
import { useCallback } from 'react';
import { DynamicHistogramWidget } from './DynamicHistogramWidget';

export interface DynamicHistogramWidgetWrapperProps<
  T extends Record<string, unknown> = Record<string, unknown>,
> {
  query: string;
  widgetId: string;
  handleRemoveWidget?: (widgetId: string) => void;
  shortDescription?: string;
  mapBar: (item: T) => { name: string; value: number };
}

export const DynamicHistogramWidgetWrapper = <
  T extends Record<string, unknown> = Record<string, unknown>,
>({
  query,
  widgetId,
  handleRemoveWidget,
  shortDescription,
  mapBar,
}: DynamicHistogramWidgetWrapperProps<T>) => {
  const dataQuery = gql`
    ${query}
  `;
  const { data, loading, error, refetch } = useApolloQuery(dataQuery, {
    notifyOnNetworkStatusChange: true,
  });

  // Get the main data array (e.g., data.Sector)
  const mainKey = data ? Object.keys(data)[0] : undefined;
  const chartData = mainKey ? data[mainKey] : [];
  const memoizedMapBar = useCallback(mapBar, [mapBar]);

  console.log('chartData', chartData);

  return (
    <DynamicHistogramWidget
      data={chartData}
      isLoading={loading}
      error={error ?? null}
      refetch={refetch}
      widgetId={widgetId}
      handleRemoveWidget={handleRemoveWidget}
      title={shortDescription}
      mapBar={memoizedMapBar}
    />
  );
};
